// Paleta semântica única dos badges/tags de status, tipo e marcadores (issue #1049).
// Regra: balão SEMPRE preenchido com a cor + texto NEGRITO BRANCO.
// Mesmo significado → mesma cor em todas as telas.

export const STATUS_PALETTE = {
	ok: "#2e9e4f", // verde — concluído / conferido / resolvido / estoque lançado / ok
	andamento: "#1976d2", // azul — em andamento / em análise / neutro
	atencao: "#ef6c00", // laranja — atenção / aguardando / com ocorrência
	erro: "#e53935", // vermelho — erro / atrasado / não cadastrado
	novo: "#64b5f6", // azul claro — "novo"
	neutro: "#616161", // cinza — tipo sem severidade / entregue
} as const;

export type StatusToken = keyof typeof STATUS_PALETTE;

/** Estilo padrão do balão: fundo colorido + texto negrito branco. */
export function balao(hex: string) {
	return { backgroundColor: hex, color: "#fff", fontWeight: 700 } as const;
}

/** Conveniência: estilo do balão a partir do token semântico. */
export function balaoToken(token: StatusToken) {
	return balao(STATUS_PALETTE[token]);
}
